import toast from 'react-hot-toast';
export const open503Toast = () => {
  toast.error('مشکلی پیش آمده است. لطفا دقایقی دیگر تلاش کنید.', {
    duration: 3000,
    id: '503-toast-error'
  });
};